import { cx } from '@linaria/core';
import { CircularButton } from '@ui/kit';
import { button } from './atom.chevrons.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function Chevrons(props) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: cx(button, "prev"),
      children: /*#__PURE__*/jsx(CircularButton, {
        inversed: true,
        "aria-label": "Gå til forrige slide",
        onClick: props.onPrevClick
      })
    }), /*#__PURE__*/jsx("div", {
      className: cx(button, "next"),
      children: /*#__PURE__*/jsx(CircularButton, {
        "aria-label": "Gå til næste slide",
        onClick: props.onNextClick
      })
    })]
  });
}

export { Chevrons };
//# sourceMappingURL=atom.chevrons.js.map
